import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  activeFormatter,
  showConfirmDialog,
  formatDate,
  lockedFormatter,
  useForceUpdate,
  showDialog,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import LoadingFetchData from "../../utility/LoadingFetchData";
import SVG from "react-inlinesvg";
import { Button, Col, Row } from "react-bootstrap";

export const ModalClientTable = ({
  data,
  page,
  sizePerPage,
  sortField,
  sortOrder,
  onTableChange,
  totalSize,
  loading,
  setListClient,
  listClient,
  handleClose,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const forceUpdate = useForceUpdate();

  useEffect(() => {
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState(data);

  const columns = [
    {
      text: "Client Code",
      dataField: "client_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Client Name",
      dataField: "client_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
  ];
  const options = {
    page: page < 0 ? 1 : page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  const [selectedRows, setSelectedRows] = useState([]);

  const onSelectRow = {
    mode: "checkbox",
    onSelectAll: (status) => {
      if (status === true) {
        setSelectedRows(tableData);
      } else {
        setSelectedRows([]);
      }
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
    },
  };

  const handleSubmit = () => {
    // Validation
    const result = selectedRows.filter(
      (elem) =>
        !listClient.find(({ client_id }) => elem.client_id === client_id)
    );
    // cari yang sama
    const result2 = selectedRows.filter((elem) =>
      listClient.find(({ client_id }) => elem.client_id === client_id)
    );
    setListClient((listClient) => [...listClient, ...result]);
    forceUpdate();
    setSelectedRows([]);
    if (result2.length > 0) {
      showDialog("Client already exist");
    }
    handleClose();
  };

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-4"
        bootstrap4
        
        keyField="client_id"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        sort={{ dataField: sortField, order: sortOrder }}
        hover
        striped
        selectRow={onSelectRow}
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>

      <Row className="mt-6 justify-content-end">
        <Button variant="outline-primary mr-5" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Submit{" "}
        </Button>
      </Row>
      {/* Footer */}
    </>
  );
};
